import { render, staticRenderFns } from "./SupportTabs.vue?vue&type=template&id=33b2fc46&"
import script from "./SupportTabs.vue?vue&type=script&lang=js&"
export * from "./SupportTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b2fc46')) {
      api.createRecord('33b2fc46', component.options)
    } else {
      api.reload('33b2fc46', component.options)
    }
    module.hot.accept("./SupportTabs.vue?vue&type=template&id=33b2fc46&", function () {
      api.rerender('33b2fc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/support/components/SupportTabs.vue"
export default component.exports